export default "__VITE_ASSET__fb32df7d__"